import { useTranslation } from 'react-i18next';
import { cn } from '@utils/cn';
import { SERIES_DAY_STATUSES, seriesDayLegendStyle } from './constants';
import { SeriesCalendarLegendProps } from './types';

export const SeriesCalendarLegend = ({ modifiers }: SeriesCalendarLegendProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'schedule.seriesCalendar' });
  const items = [
    'current' as const,
    ...SERIES_DAY_STATUSES.filter((status) => modifiers[status].length > 0),
  ];

  return (
    <div className="flex max-w-[280px] flex-wrap gap-x-3 gap-y-1 border-t border-neutral-200 px-3 py-2">
      {items.map((item) => (
        <span key={item} className="flex items-center gap-1.5 text-xs text-neutral-600">
          <span className={cn('h-3 w-3 rounded-sm border', seriesDayLegendStyle[item])} />
          {t(item)}
        </span>
      ))}
    </div>
  );
};
